<div class="flamboyant-loader" *ngIf="isOpened">
  <div class="flamboyant-box">
    <div class="flamboyant-indicator"></div>
  </div>
</div>
